module.exports = __webpack_public_path__ + "static/logo-2affb75e3e26e9bd51e236586b5cce03.svg";